'use client';
import React, { useCallback, useEffect, useRef } from 'react';
import { Search, X } from 'lucide-react';
import { useWorksheetStore } from './worksheetStore';

export default function WorksheetSearchBar() {
  const { searchQuery, setSearchQuery } = useWorksheetStore();
  const inputRef = useRef<HTMLInputElement>(null);

  const handleClear = useCallback(() => {
    setSearchQuery('');
    inputRef?.current?.focus();
  }, [setSearchQuery]);

  return (
    <div className="relative max-w-lg mx-auto">
      <Search
        size={18}
        className="absolute left-4 top-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none"
      />
      <input
        ref={inputRef}
        type="text"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e?.target?.value)}
        placeholder="Search worksheets… e.g. 'multiplication grade 4'"
        className="w-full pl-11 pr-10 py-3 rounded-xl border border-border bg-card text-foreground text-sm placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent card-shadow-md transition-all duration-150"
        aria-label="Search worksheets"
      />
      {searchQuery && (
        <button
          onClick={handleClear}
          className="absolute right-3 top-1/2 -translate-y-1/2 p-1 rounded-md hover:bg-muted transition-colors duration-150"
          aria-label="Clear search"
        >
          <X size={14} className="text-muted-foreground" />
        </button>
      )}
    </div>
  );
}